// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","970":"component---src-pages-about-tsx"}[chunkId] + "-" + {"245":"883e781032d473a97d2e","970":"96d1867b7658d67319bd"}[chunkId] + ".js";
};